import { FiInfo, FiAlertTriangle, FiCheckCircle, FiLock } from "react-icons/fi";

const ICONS = { info: FiInfo, warning: FiAlertTriangle, success: FiCheckCircle, neutral: FiLock, danger: FiAlertTriangle };

export default function Banner({ tone = "info", title, children, action }) {
  const Icon = ICONS[tone] || FiInfo;
  return (
    <div className={`banner banner-${tone}`} role={tone === "warning" || tone === "danger" ? "alert" : "status"}>
      <Icon size={18} aria-hidden="true" className="banner-icon" />
      <div className="banner-body">
        {title && <p className="banner-title">{title}</p>}
        {children && <div className="banner-text">{children}</div>}
      </div>
      {action && <div className="banner-action">{action}</div>}
    </div>
  );
}
